export const defaultRegistry = "https://nexus.kontur.host/repository/kontur-npm-group";
